/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import addCSSClass from "src/libs/layout-app/utils/addCSSClass";
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass";
import { getCssDemention } from "src/libs/utilities/getCssDemention";
import { CARD_FIELD_TYPE } from "src/modules/pe-landing-module/data/interfaces";
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition";
import Card, { ICardProps } from "./Card";
import { __ } from "src/libs/utilities";

/* Landing Card for horizontal accordeon */
export interface IHAccordeonCardProps extends ICardProps {
  isOpen: boolean;
  setOpen: () => void;
}
const HAccordeonCard = (props: IHAccordeonCardProps): JSX.Element => {
    const { data, contentData, section, isOpen } = props;
    const composition = useComposition(section);
    const height: number = parseInt((contentData.height || 400).toString());
    useEffect(() => {
        addCSSClass(
        `landing-card-${data.id}`,
        `.landing-card-${data.id} {
                ${data.cardColor ? `background-color: ${ data.cardColor };` : ``}
                min-height:${getCssDemention(height, "400px")};
                z-index: ${data.i}; 
                .haccordeon-card-title-container {
                    min-width:${getCssDemention(height - 100, "380px")};
                    height: 100px!important;
                    left: 0!important;
                    top: calc(100% - 100px)!important;
                    transform-origin: 0 0!important;
                    transform: rotate(-90deg)!important;
                    align-items: flex-start!important;
                }
            }`
        );

        return () => {
        removeCSSClass(`landing-card-${data.id}`);
        };
    }, [composition]) 
 
    const onOpen = ( )=> { 
        props.setOpen() 
    }
    
    const getTitle = () => {
        if( !!data.cardTitle ) {
            return data.cardTitle
        }
        const isTitle: number = contentData.card_fields.findIndex( f => f.type === CARD_FIELD_TYPE.TITLE )
        if( isTitle > -1 ) {            
            // console.log( data.title?.data , isTitle)            
            return data.title?.data
        }
        return __("Card") + " " + data.id
    }

    return (
        <div
            className={`landing-haccordeon-card-container landing-card-${data.id} ${
                isOpen ? "open" : ""
            }`}
        >
            <div className="haccordeon-card-cover-container">
                <div 
                    className="haccordeon-card-cover" 
                    onClick={ () => onOpen() }  
                >
                    <div className="haccordeon-card-title-container">
                        <div className="haccordeon-card-title">
                            <div className="w-100 my-title">
                                { getTitle() } 
                            </div>
                        </div>
                        <div className="haccordeon-card-secription">
                            {data.cardDescription}
                        </div>
                    </div>
                    <div className="haccordeon-card-icon">
                        <i className={data.cardIcon} />
                    </div>
                </div>
            </div>
            <div className="haccordeon-card-content-container">
                <Card
                    key={ data.id }
                    data={ { ...data, i: props.i } }
                    width={ 300 }
                    contentData={ contentData }
                    section={ props.section }
                />
            </div>
        </div>
    );
};
export default HAccordeonCard;
